import {
    request,
} from '../request.js'

// 获取
export function reqGetVersionList() {
    return request({
        url: '/web/back/versions/getVersionList',
        method: 'get',
    })
}

// 查询
export function reqSearchVersion(data){
    return request({
        url: '/web/back/userVersions/selectByUserVersion',
        method: 'post',
        data
    })
}

// 推送新版本信息
export function reqPushVersion(data) {
    return request({
        url: '/web/back/sys/pushPhone/pushNewVsersion',
        method: 'post',
        data
    })
}

// 版本管理  /web/back/versions/list
export function reqVersionList(data) {
    return request({
        url: '/web/back/versions/list',
        method: 'post',
        data
    })
}
//    post 修改  
export function reqUpdateVer(data) {
    return request({
        url: '/web/back/versions/update',
        method: 'post',
        data
    })
}

//     delete 删除
export function reqDeleteVer(id) {
    return request({
        url: '/web/back/versions/delete',
        method: 'delete',
        params: {
            id
        }
    })
}

// 添加
export function reqAddVer(data) {
    return request({
        url: '/web/back/versions/insert',
        method: 'post',
        data
    })
}
// 上传apk
export function uploadApk(data) {
    return request({
        url: '/web/back/versions/uploadApk',
        method: 'post',
        data
    })
}

